import { CheckCircle2, Circle } from 'lucide-react';
import Panel from './Panel';

const ChecklistPanel = ({ checklist, onNavigate }) => {
  const { items, completed } = checklist;
  return (
    <Panel title="Getting started" subtitle={`${completed} of ${items.length} complete`} testId="getting-started">
      <div className="h-1.5 w-full rounded-full bg-muted mb-4" role="progressbar" aria-valuemin={0} aria-valuemax={items.length} aria-valuenow={completed}>
        <div className="h-full rounded-full bg-primary" style={{ width: `${(completed / items.length) * 100}%` }} />
      </div>
      <ul className="space-y-2">
        {items.map(({ id, label, done, to }) => (
          <li key={id} className="flex items-center gap-2 text-sm">
            {done ? (
              <>
                <CheckCircle2 className="w-4 h-4 text-success shrink-0" />
                <span className="line-through text-muted-foreground">{label}</span>
              </>
            ) : (
              <>
                <Circle className="w-4 h-4 text-muted-foreground shrink-0" />
                <button type="button" onClick={() => onNavigate(to)} className="underline underline-offset-2 hover:no-underline text-left">
                  {label}
                </button>
              </>
            )}
          </li>
        ))}
      </ul>
    </Panel>
  );
};

export default ChecklistPanel;
